<template>
  <v-btn
    color="amber darken-2"
    dark
    x-large
    block
    class="px-12 py-8 my-2 round-corner"
    @click="cloneCollection"
  >
    Fazer backup de usuários
  </v-btn>
</template>

<script>
// import firebase from 'firebase'
import db from '@/firebase/init'
import moment from 'moment'

export default {
  name: "BackupUsers",
  data() {
    return {
      users: []
    }
  },
  methods: {
    cloneCollection() {
      // console.log('oi')
      this.users = []

      db.collection('usuarios')
        .get()
        .then(snapshot => {
          // console.log(snapshot.docs)
          snapshot.docs.forEach(doc => {
            // console.log(doc.data())
            this.users.push(doc.data())
          });
          console.log(moment().format('YYYY-MM-DD') + "_" + moment.now(), this.users)
          db.collection('users-bckp')
            .doc(moment().format('YYYY-MM-DD') + "_" + moment.now())
            .set({
              users: this.users
            })
            .then(() => {
              console.log("Backup feito com sucesso")
            })
            .catch((e) => {
              console.log("Ops, parece que ocorreu um erro: ", e)
            })
        })
    },
  },
  mounted() {
    moment.locale("pt-br");
  }
}
</script>